module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-mask-parent"
  }, [_c('component-title', {
    attrs: {
      "config": _vm.config
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('div', [_c('data-table', {
    attrs: {
      "my-ajax": _vm.dataTableAjax,
      "dt-id": _vm.gridId,
      "row-id": 'product_id',
      "columns": _vm.columns,
      "column-defs": _vm.columnDefs(),
      "refresh": _vm.DTRefresh,
      "refresh-view-with-preserve-paging": _vm.DTRefreshWithPreservePaging,
      "on-click-element": ".row-details",
      "on-click-element-event": _vm.onClickEvent,
      "on-page-change": _vm.onPageChange,
      "sort": _vm.defaultSort.length > 0,
      "order": _vm.defaultSort,
      "page-length": _vm.pagination
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-component-components"
  }, [_vm._l((_vm.getComponents), function(component) {
    return [_c(_vm.loadComponent(component.type), {
      tag: "component",
      attrs: {
        "config": component.config,
        "parent-state": _vm.state
      }
    })]
  }), _vm._v(" "), (_vm.showPagination) ? _c('div', {
    staticClass: "pagination-parent"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('Pages on side')) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination),
      expression: "pagination"
    }],
    staticClass: "pagination",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pagination = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.paginationChange]
    }
  }, _vm._l(([10, 50, 100, 300, 500]), function(_pagination) {
    return _c('option', {
      domProps: {
        "value": _pagination
      }
    }, [_vm._v(_vm._s(_pagination) + "\n                ")])
  }), 0)]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74deaff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GridComponent.vue
// module id = 1327
// module chunks = 2